
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h2>Basketball Championship</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="breadcrumb-bottom-img">
		<img
			src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
	</div>
</section>
<section class="section section-sm fide-chess2021 section-banner-bg-1">
	<div class="container">
		<div class="sec-title text-center">
			<h2>G H Raisoni Memorial Maha Basket  <span > State Championship Event  </span></h2>
		</div>
		<p>GHRSCF organised G H Raisoni Memorial Maha Basket 3x3 State Championship in association with Maha Basketball
			association under the aegis of Nagpur District Basketball Association from 7th July to 9th July, 2023 at
			Shivaji Nagar, Gymkhana Nagpur. This is the first-ever FIBA Endorsed 3x3 State Level tournament in
			Maharashtra.</p>
		<p>The tournament provided an engaging chance for the teams to compete in thrilling matches at various levels to
			prove their talent. Total 58 teams participated from all districts of Maharashtra U -23 Men sixteen teams,
			U-23 (women) twelve teams, U-18 (Men) sixteen teams, U-18 (Women) fourteen teams participated. Satara
			Gymkhana (Men) team won U-23 category, Deccan Pune (Women) team won U-23 category, Deccan Gymkhana (Women)
			team won U-18 category, CPSA Pune (Men) team won U-18. The winners were awarded with trophies, certificates
			and cash prizes.
	</div>
</section>
<section class="section section-sm fide-chesscompetition section-banner-bg-1">
	<div class="container">
		<div class="border-line-sm"></div>
		<div class="row row-cols-1 row-cols-md-2">
			<div class="col">
				<div class="gall-ery">

					<div class="row">
						<div class="col-md-8">
							<div class="widget_title inner-title gall-sys shadow-text-sm">
								<h4 class="fw-bold">Media Coverage</h4>
							</div>
						</div>
					</div>

					<div class="lightBox--gallery">
						<ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
							<li class="col"
								data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/basketball1.webp"
								data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/basketball1.webp">
								<a href="Javascript:void(0);">
									<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/basketball1.webp"
										alt="GHRSCF" title="GHRSCF" class="img-fluid" />
									<div class="light-gallery-poster">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
									</div>
								</a>
							</li>
							<li class="col"
								data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/basketball2.webp"
								data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/basketball2.webp">
								<a href="Javascript:void(0);">
									<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/basketball2.webp"
										alt="GHRSCF" title="GHRSCF" class="img-fluid" />
									<div class="light-gallery-poster">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
									</div>
								</a>
							</li>
						</ul>
					</div>
				</div>
			</div>

			<div class="col">
				<div class="gall-ery">
					<div class="row">
						<div class="col-md-8">
							<div class="widget_title inner-title gall-sys shadow-text-sm">
								<h4 class="fw-bold">Photos</h4>
							</div>
						</div>
						<div class="col-md-4 text-end">
							<a href="/photogallery#basketball" class="cmn-button"><span>
									View More</span>
							</a>
						</div>
					</div>
					<div class="lightBox--gallery">
						<ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
							<li class="col"
								data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/basketball/RGI-1.webp"
								data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/basketball/RGI-1.webp">
								<a href="Javascript:void(0);">
									<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/basketball/RGI-1.webp"
										alt="GHRSCF" title="GHRSCF" class="img-fluid" />
									<div class="light-gallery-poster">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
									</div>
								</a>
							</li>
							<li class="col"
								data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/basketball/RGI-2.webp"
								data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/basketball/RGI-2.webp">
								<a href="Javascript:void(0);">
									<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/basketball/RGI-2.webp"
										alt="GHRSCF" title="GHRSCF" class="img-fluid" />
									<div class="light-gallery-poster">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
									</div>
								</a>
							</li>
							<li class="col"
								data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/basketball/RGI-3.webp"
								data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/basketball/RGI-3.webp">
								<a href="Javascript:void(0);">
									<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/basketball/RGI-3.webp"
										alt="GHRSCF" title="GHRSCF" class="img-fluid" />
									<div class="light-gallery-poster">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
									</div>
								</a>
							</li>
							<li class="col"
								data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/basketball/RGI-4.webp"
								data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/basketball/RGI-4.webp">
								<a href="Javascript:void(0);">
									<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/basketball/RGI-4.webp"
										alt="GHRSCF" title="GHRSCF" class="img-fluid" />
									<div class="light-gallery-poster">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
									</div>
								</a>
							</li>
							<li class="col"
								data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/basketball/RGI-5.webp"
								data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/basketball/RGI-5.webp">
								<a href="Javascript:void(0);">
									<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/basketball/RGI-5.webp"
										alt="GHRSCF" title="GHRSCF" class="img-fluid" />
									<div class="light-gallery-poster">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
									</div>
								</a>
							</li>
							<li class="col"
								data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/basketball/RGI-6.webp"
								data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/basketball/RGI-6.webp">
								<a href="Javascript:void(0);">
									<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/basketball/RGI-6.webp"
										alt="GHRSCF" title="GHRSCF" class="img-fluid" />
									<div class="light-gallery-poster">
										<img
											src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
									</div>
								</a>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>

	</div>
</section>
